import React, { useEffect, useState } from "react";
import { Card, Table, Spinner, Button, Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import SmartPagination from "../Report/EmailCampaignRunReport/DynamicSmartPagination";
import { getSpammedDidList } from "../../store/slices/smartConnect/smartConnectDids";
import Layout from "../../layouts/default";
import { toast } from "react-toastify";

const LIMIT = 10;

function SmartConnectDeletedDidList() {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    did_number: "",
    agent_type: "ALL",
  });

  const { spammedDids } = useSelector((state) => state.smartConnectDIDsReducer);

  const { data = [], pagination = {}, loading } = spammedDids || {};

  const fetchData = async (pageNo = 1, overrideFilters) => {
    try {
      await dispatch(
        getSpammedDidList({
          limit: LIMIT,
          skip: (pageNo - 1) * LIMIT,
          filters: overrideFilters || {
            did_number: filters.did_number || undefined,
            agent_type: filters.agent_type || undefined,
            status: "inactive",
          },
        }),
      ).unwrap();
    } catch (err) {
      const msg = err || err?.message;
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchData(page);
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchData(1);
  };

  const handleReset = () => {
    setFilters({
      did_number: "",
      agent_type: "ALL",
    });
    setPage(1);
    fetchData(1, {
      status: "inactive",
    });
  };

  const showValue = (value) => value ?? "-";

  return (
    <Layout>
      {/* Header */}
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h3 className="mb-0">Deleted / Spammed DIDs</h3>
      </div>

      {/* Filters */}
      <Card className="mb-3 shadow-sm">
        <Card.Body>
          <Row className="g-2 align-items-end">
            <Col md={4}>
              <Form.Label className="small text-muted">DID Number</Form.Label>
              <Form.Control
                placeholder="Enter DID Number"
                value={filters.did_number}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    did_number: e.target.value,
                  })
                }
              />
            </Col>

            <Col md={4}>
              <Form.Label className="small text-muted">Agent Type</Form.Label>
              <Form.Select
                value={filters.agent_type}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    agent_type: e.target.value,
                  })
                }
              >
                <option value="">All</option>
                <option value="CSM">CSM</option>
                <option value="SALES_SETTLEMENT">Sales / Settlement</option>
                <option value="DYNAMIC_GROUP">DYNAMIC GROUP</option>
              </Form.Select>
            </Col>

            <Col md="auto">
              <Button size="sm" onClick={handleSearch}>
                Apply Filters
              </Button>
            </Col>

            <Col md="auto">
              <Button
                size="sm"
                variant="outline-secondary"
                onClick={handleReset}
              >
                Reset
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Table */}
      <Card className="shadow-sm">
        <Card.Body className="p-0">
          <Table bordered hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>DID NUMBER</th>
                <th>AGENT TYPE</th>
                <th>DELETED BY</th>
                <th>REASON</th>
                <th>DELETED AT</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="text-center py-4">
                    <Spinner size="sm" />
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">
                    No Deleted DIDs Found
                  </td>
                </tr>
              ) : (
                data.map((row, index) => (
                  <tr key={row.id || index}>
                    <td>{(page - 1) * LIMIT + index + 1}</td>
                    <td>{showValue(row.did_number)}</td>
                    <td>{showValue(row.agent_type)}</td>
                    <td>
                      {row?.unassigned_by_user?.name ||
                        row.unassigned_by ||
                        "-"}
                    </td>
                    <td>
                      {showValue(
                        row.reason ||
                          (row.unassigned_reason
                            ? "SPAMMED BY SYSTEM AS PER SETTING"
                            : "SPAMMED"),
                      )}
                    </td>
                    <td>
                      {row.unassigned_at
                        ? new Date(row.unassigned_at).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                          })
                        : "-"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {pagination?.totalPages > 1 && (
            <div className="p-3">
              <SmartPagination
                currentPage={page}
                totalPages={pagination.totalPages}
                onPageChange={setPage}
              />
            </div>
          )}
        </Card.Body>
      </Card>
    </Layout>
  );
}

export default SmartConnectDeletedDidList;
